import React from 'react';
import './App.scss';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useMsalAuthentication} from "@azure/msal-react";
import RequestInterceptor from "./Components/RequestInterceptor";
import {InteractionType} from "@azure/msal-browser";
import './custom.scss';
import {Route, Routes} from "react-router";
import Layout from "./Components/Layout";
import Home from "./Components/Home";
import PageNotFound from "./Components/PageNotFound";
import Soknader from "./Components/soknader/SoknaderLayout";
import SoknadEdit from "./Components/soknader/SoknadEdit";
import SoknadView from "./Components/soknader/SoknadView";


function App() {
    useMsalAuthentication(InteractionType.Redirect);
  return (
      <>
      <AuthenticatedTemplate>
          <RequestInterceptor>
              <Routes>
                  <Route element={<Layout />}>
                      <Route index element={<Home></Home>}></Route>
                      <Route path={"soknader/:id/edit"} element={<SoknadEdit />}></Route>
                      <Route path={"soknader/:id"} element={<SoknadView />}></Route>
                      <Route path={"soknader/*"} element={<Soknader />}></Route>
                      <Route path={"*"} element={<PageNotFound></PageNotFound>}></Route>
                  </Route>
              </Routes>
          </RequestInterceptor>
      </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
              Et øyeblikk...
          </UnauthenticatedTemplate>
      </>
  );
}

export default App;
